import React, { useCallback, useEffect, useState } from "react";
import styles from "./Customers.module.css";
import Footer from "../../components/ui/Footer";
import Navbar from "../../components/ui/Navbar";
import Table from "../../components/table/Table";
import successImage from "../../assets/grunge-green-success-word-with-star-icon-rubber-vector-33034681-removebg-preview 1.png";
import Menu from "../../components/ui/Menu";
import FixedAgent from "../../utils/api/FixedAgent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { userDataActions } from "../../store/redux-store/Index";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/ui/Modal";
import SkeletonLoader from "../../components/ui/Loader";
// import { useNavigate } from "react-router";

function Customers(props) {
  const [addCustomerModalOpen, setaddCustomerModalOpen] = useState(false);
  const [customerAdded, setCustomerAdded] = useState(false);
  const [sendExpiryModal, setSendExpiryModal] = useState(false);
  const [sendExpiryModalData, setSendExpiryModalData] = useState(null);
  const [allCustomers, setAllCustomers] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [filteredCustomers, setFilteredCustomers] = useState(allCustomers);
  // const [pageNumber, setPageNumber] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [url, setUrl] = useState("");
  const [filterStatus, setFilterStatus] = useState(null);
  const [pageIsLoading, setPageIsLoading] = useState(false);
  const [updateMessage, setUpdateMessage] = useState("");

  const [input, setInput] = useState({
    plateNumber: "",
    phoneNumber: "",
    useCustomerNumber: true,
  });
  const [useCustomerNumber, setUseCustomerNumber] = useState(false);

  const [customerStatus, setCustomerStatus] = useState({
    active: 0,
    dueSoon: 0,
    expired: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const token = useSelector((state) => state.userData.loginData.token);

  const userDetails = useSelector((state) => state.userData.personalInfo);

  // const navigate = useNavigate();
  // console.log(userDetails);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  const fetchCustomers = useCallback(async () => {
    try {
      setPageIsLoading(true);
      setCustomerStatus({
        active: 0,
        dueSoon: 0,
        expired: 0,
      });
      const response = await FixedAgent.getAllCustomers({
        token,
        // page_no: pageNumber,
      });

      setAllCustomers(response?.data?.data);
      response?.data?.data?.forEach((customer, index) => {
        checkCustomerStatus(customer);
      });

      setPageIsLoading(false);
    } catch (error) {
      setPageIsLoading(false);
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  useEffect(() => {
    const customers = allCustomers?.data || allCustomers;
    let filtered = customers;

    if (searchInput) {
      console.log("Okay");
      filtered = customers?.filter((customer) =>
        customer.plate_no?.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    // if (filterStatus === "expired") {
    //   filtered = filtered?.filter((customer) =>
    //     customerStatusMatchesFilter(customer, "expired")
    //   );
    // } else if (filterStatus === "dueSoon") {
    //   filtered = filtered?.filter((customer) =>
    //     customerStatusMatchesFilter(customer, "dueSoon")
    //   );
    // } else if (filterStatus === "active") {
    //   filtered = filtered?.filter((customer) =>
    //     customerStatusMatchesFilter(customer, "active")
    //   );
    // }

    setFilteredCustomers(filtered);
  }, [searchInput, allCustomers, filterStatus]);

  // const customerStatusMatchesFilter = (customer, statusType) => {
  //   const parseDate = (dateStr) => {
  //     if (dateStr.includes("/")) {
  //       let [day, month, year] = dateStr.split("/").map((part) => part.trim());

  //       if (year.length === 2) {
  //         year = parseInt(year) < 50 ? "20" + year : "19" + year;
  //       }

  //       return new Date(`${year}-${month}-${day}`).getTime();
  //     } else if (dateStr.includes("-")) {
  //       return new Date(dateStr).getTime();
  //     } else {
  //       throw new Error("Invalid date format");
  //     }
  //   };
  //   const currentDate = new Date().getTime();
  //   const oneMonthAhead = currentDate + 30 * 24 * 60 * 60 * 1000;

  //   const expiryDates = [
  //     customer.road_expiry_date && parseDate(customer.road_expiry_date),
  //     customer.vl_expiry_date && parseDate(customer.vl_expiry_date),
  //     customer.expiry_date && parseDate(customer.expiry_date),
  //   ].filter(Boolean);

  //   if (expiryDates.length === 0) return false;

  //   const isExpired = expiryDates.some((date) => date < currentDate);
  //   const isDueSoon = expiryDates.some(
  //     (date) => date > currentDate && date < oneMonthAhead
  //   );
  //   const isActive = expiryDates.every((date) => date > currentDate);

  //   if (statusType === "expired") return isExpired;
  //   if (statusType === "dueSoon") return isDueSoon;
  //   if (statusType === "active") return isActive;

  //   return false;
  // };

  const fetchUserSecondInsuranceData = useCallback(
    async (plate_no) => {
      try {
        const getUserRoadRes = await FixedAgent.getRoadData({
          plate_no: plate_no,
          token,
        });

        setUpdateMessage("Adding new customer");

        const addNewUser = await FixedAgent.addNewCustomer({
          phone_no: useCustomerNumber
            ? input.phoneNumber
            : "0" + userDetails?.phone_no,
          plate_no: input.plateNumber,
          fullname: "",
          token: token,
          road_expiry_date: getUserRoadRes.data.data.RwcExp,
          road_message: getUserRoadRes.data.data.message,
          state: "lagos",
        });
        setUpdateMessage("Customer Added");

        setCustomerAdded(true);

        fetchCustomers();
        setUpdateMessage("");

        setIsLoading(false);
        return addNewUser;
      } catch (err) {
        setIsLoading(false);

        if (err?.response?.data?.message === "Unauthenticated") {
          dispatch(userDataActions.logout());
          window.location.reload();
        }
        // if (
        //   err?.response?.data?.message ===
        //   "Policy details are invalid or not matching."
        // ) {
        //   setIsLoading(true);

        // } else {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }
      // }
    },
    [
      token,
      dispatch,
      input.plateNumber,
      input.phoneNumber,
      fetchCustomers,
      useCustomerNumber,
      userDetails?.phone_no,
    ]
  );

  const addCustomerHandler = async () => {
    try {
      setIsLoading(true);
      const getUserRoadRes = await FixedAgent.getRoadData({
        plate_no: input.plateNumber,
        token,
      });

      let getNiconInsuranceRes;
      try {
        getNiconInsuranceRes = await FixedAgent.getNiconInsuranceData({
          plate_no: input.plateNumber,
          token,
        });
      } catch (error) {
        console.error(
          "Failed to fetch Nicon insurance data",
          error?.response.data.message
        );

        toast.error(error?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }

      setUpdateMessage("Fetching Your Insurance Data");
      let getInsuranceRes;
      try {
        getInsuranceRes = await FixedAgent.getInsuranceData({
          plate_no: input.plateNumber,
          token,
        });
        setUpdateMessage("Insurance Data Fetched");
      } catch (error) {
        setUpdateMessage("Insurance Data Fetch Failed");
        toast.error(error?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
        getInsuranceRes = { data: { message: "" } };
      }

      // const getUserVehicleInfo = await FixedAgent.getCustomerOnlineData({
      //   plate_no: input.plateNumber,
      //   token,
      // });

      // let insuranceData;
      // if (getUserVehicleInfo.data.data.VehicleMake === "") {
      // setUpdateMessage("Fetching Your Insurance Data");

      const getUserInsuranceRes =
        await FixedAgent.getCustomerInsuranceSecondOnlineData({
          plate_no: input.plateNumber,
          token,
        });
      setUpdateMessage("Insurance Data Fetched");

      //   console.log(getUserInsuranceRes.data);

      //   insuranceData = getUserInsuranceRes.data;
      // }
      setUpdateMessage("Adding Customer");
      const addNewUser = await FixedAgent.addNewCustomer({
        phone_no: useCustomerNumber
          ? input?.phoneNumber
          : "0" + userDetails?.phone_no,
        plate_no: input.plateNumber,
        fullname:
          getNiconInsuranceRes.data.fields.insured_name ||
          getUserInsuranceRes.data?.data?.full_name,
        token: token,
        engine_number:
          getNiconInsuranceRes.data.fields.engine_no ||
          getUserInsuranceRes.data?.data?.engine_no,
        chassis:
          getNiconInsuranceRes.data.fields.chasis_no ||
          getUserInsuranceRes.data?.data?.chassis_no,
        make:
          getNiconInsuranceRes.data.fields.vehicle_make_custom ||
          getUserInsuranceRes.data?.data?.make,
        model:
          getNiconInsuranceRes.data.fields.vehicle_model_custom ||
          getUserInsuranceRes.data?.data?.model,
        year:
          getNiconInsuranceRes.data.fields.year_of_make ||
          getUserInsuranceRes.data?.data?.year,
        road_expiry_date: getUserRoadRes.data.data.RwcExp,
        expiry_date: getInsuranceRes.data.message,
        road_message: getUserRoadRes.data.data.message,
        color:
          getNiconInsuranceRes.data.fields.color ||
          getUserInsuranceRes.data?.data?.color,
        state: "lagos",
      });
      setUpdateMessage("Customer Added");

      setCustomerAdded(true);

      fetchCustomers();
      setIsLoading(false);
      setUpdateMessage("");

      return addNewUser;
    } catch (err) {
      setIsLoading(false);
      if (
        err?.response?.data?.message ===
        "Policy details are invalid or not matching."
      ) {
        setIsLoading(true);
        fetchUserSecondInsuranceData(input.plateNumber);
      } else {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }

      if (err?.response?.data?.message === "Unauthenticated") {
        dispatch(userDataActions.logout());
        window.location.reload();
      }
    }
  };

  const checkCustomerStatus = (customer) => {
    const parseDate = (dateStr) => {
      if (dateStr.includes("/")) {
        let [day, month, year] = dateStr.split("/").map((part) => part.trim());

        if (year.length === 2) {
          year = parseInt(year) < 50 ? "20" + year : "19" + year;
        }
        return new Date(`${year}-${month}-${day}`).getTime();
      } else if (dateStr.includes("-")) {
        return new Date(dateStr).getTime();
      } else {
        throw new Error("Invalid date format");
      }
    };
    const currentDate = new Date().getTime();
    const roadDueDate = customer.road_expiry_date
      ? parseDate(customer.road_expiry_date)
      : null;

    const vlDueDate = customer.vl_expiry_date
      ? parseDate(customer.vl_expiry_date)
      : null;
    const insuranceDueDate = customer.expiry_date
      ? parseDate(customer.expiry_date)
      : null;

    if (roadDueDate !== null) {
      if (roadDueDate < currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          expired: prevStatus.expired + 1,
        }));
      } else if (roadDueDate - currentDate <= 30 * 24 * 60 * 60 * 1000) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          dueSoon: prevStatus.dueSoon + 1,
        }));
      } else if (roadDueDate > currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          active: prevStatus.active + 1,
        }));
      }
    }

    if (vlDueDate !== null) {
      if (vlDueDate < currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          expired: prevStatus.expired + 1,
        }));
      } else if (vlDueDate - currentDate <= 30 * 24 * 60 * 60 * 1000) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          dueSoon: prevStatus.dueSoon + 1,
        }));
      } else if (vlDueDate > currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          active: prevStatus.active + 1,
        }));
      }
    }

    if (insuranceDueDate !== null) {
      if (insuranceDueDate < currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          expired: prevStatus.expired + 1,
        }));
      } else if (insuranceDueDate - currentDate <= 30 * 24 * 60 * 60 * 1000) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          dueSoon: prevStatus.dueSoon + 1,
        }));
      } else if (insuranceDueDate > currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          active: prevStatus.active + 1,
        }));
      }
    }
  };

  const handleStatClick = (status) => {
    setFilterStatus((prevStatus) => (prevStatus === status ? null : status)); // Toggle filter status
  };

  const sendSmsText = async () => {
    const message = `Dear ${
      sendExpiryModalData?.fullname
    }, the papers of your ${sendExpiryModalData?.year.toString().slice(-2)} ${
      sendExpiryModalData?.make
    } ${sendExpiryModalData?.model} with plate number ${
      sendExpiryModalData?.plate_no
    } expire on the following dates: Insurance: ${
      sendExpiryModalData?.expiry_date
        ? new Date(sendExpiryModalData?.expiry_date).toLocaleDateString(
            "en-US",
            {
              year: "2-digit",
              month: "short",
              day: "numeric",
            }
          )
        : "unknown"
    }, Vehicle License: ${
      sendExpiryModalData?.vl_expiry_date
        ? new Date(sendExpiryModalData?.vl_expiry_date).toLocaleDateString(
            "en-US",
            {
              year: "2-digit",
              month: "short",
              day: "numeric",
            }
          )
        : "unknown"
    }, Road Worthiness: ${
      sendExpiryModalData?.road_expiry_date
        ? new Date(sendExpiryModalData?.road_expiry_date).toLocaleDateString(
            "en-US",
            {
              year: "2-digit",
              month: "short",
              day: "numeric",
            }
          )
        : "unknown"
    }. Please reply to renew and avoid fines.`;

    try {
      setIsLoading(true);
      const smsRes = await FixedAgent.sendSms({
        recipients: sendExpiryModalData?.phone_no,
        message,
      });
      setIsLoading(false);
      toast.success(smsRes.data.msg, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } catch (err) {
      setIsLoading(false);

      console.log(err.response);
    }
  };

  const sendWelcomeSmsText = async () => {
    const phoneNo = input.phoneNumber.startsWith("0")
      ? "234" + input.phoneNumber.slice(1)
      : input.phoneNumber;

    const message = `*Welcome to AgentPro!* 🚗✨
    Hi,
    We're excited to have you on board! With AgentPro, you now have the tools to manage and renew the vehicle papers of your customers quickly and efficiently.
    Here's how you can get started:
    1. Log in to your AgentPro account to explore your dashboard.
    2. Add your customer's vehicle details to protect them from traffic fines. 
    3. Send reminders and renew for them. 
    4. Track all transactions and manage your clients in one place.
    If you need any help, feel free to reach out to our support team. We're here to ensure you succeed!
    Welcome once again, and we're looking forward to working with you! 🚀
    Best regards,
    The AgentPro Team.`;

    try {
      setIsLoading(true);
      const smsRes = await FixedAgent.sendSms({
        recipients: phoneNo,
        message,
      });

      setIsLoading(false);
      toast.success(smsRes.data.msg, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } catch (err) {
      setIsLoading(false);

      console.log(err.response);
    }
  };

  const openModalHandler = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const sendLinkToModal = useCallback((plate_no) => {
    setUrl(`https://payvis.ng/summary?sv=${plate_no}`);
  }, []);

  return (
    <div>
      <ToastContainer />
      <div className="menu" onClick={() => props.setShowMenu(false)}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      {sendExpiryModal && (
        <div
          className={styles.modal_overlay}
          onClick={() => setSendExpiryModal(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>Add Customer</h1>
            {!customerAdded ? (
              <div>
                <p>
                  Hello {sendExpiryModalData?.fullname}, this is a friendly
                  reminder that your car document expires as follows:
                </p>
                <ul>
                  <li>Insurance: {sendExpiryModalData?.expiry_date}</li>
                  <li>
                    Vehicle License: {sendExpiryModalData?.vl_expiry_date}
                  </li>
                  <li>Road: {sendExpiryModalData?.road_expiry_date}</li>
                  {/* <li>POC: pocExpiry</li> */}
                </ul>
                <p>Kindly reply to renew. I am here to help!</p>
                <input
                  className={styles.modal_input}
                  type="text"
                  placeholder="Phone Number"
                  defaultValue={sendExpiryModalData?.phone_no?.replace(
                    /(\d{7})/,
                    "*******"
                  )}
                />
                <button
                  className={styles.modal_button}
                  onClick={() => {
                    const phoneNo = sendExpiryModalData?.phone_no;
                    if (phoneNo) {
                      const message = `Dear ${sendExpiryModalData?.fullname}, the papers of your ${sendExpiryModalData?.year} ${sendExpiryModalData?.make} ${sendExpiryModalData?.model} with plate number ${sendExpiryModalData?.plate_no} expire on the following dates: Insurance: ${sendExpiryModalData?.expiry_date}, Vehicle License: ${sendExpiryModalData?.vl_expiry_date}, Road Worthiness: ${sendExpiryModalData?.road_expiry_date}. Please reply to renew and avoid fines.`;
                      const url = `https://api.whatsapp.com/send?phone=${phoneNo}&text=${encodeURIComponent(
                        message
                      )}`;
                      window.open(url, "_blank");
                    }
                    setSendExpiryModal(false);
                  }}
                >
                  Send whatsapp
                </button>
                <p
                  onClick={() => sendSmsText()}
                  style={{
                    textDecoration: "underline",
                  }}
                >
                  {!isLoading ? "SMS" : ""}
                </p>
              </div>
            ) : (
              <div>
                <img
                  src={successImage}
                  alt="success"
                  style={{
                    width: "130px",
                    height: "134px",
                    gap: "0px",
                    opacity: "0px",
                  }}
                />
                <button
                  className={styles.modal_button}
                  onClick={() => setSendExpiryModal(false)}
                >
                  Send whatsapp
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {addCustomerModalOpen && (
        <div
          className={styles.modal_overlay}
          onClick={() => {
            setCustomerAdded(false);
            setaddCustomerModalOpen(false);
          }}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>Add Customer</h1>
            {!customerAdded ? (
              <div>
                {/* <p className={styles.modal_description}>
                  Dear Customer, the papers of your
                </p> */}
                <input
                  className={styles.modal_input}
                  type="text"
                  name="plateNumber"
                  onChange={handleInputChange}
                  value={input.plateNumber}
                  placeholder="Plate Number"
                />
                <input
                  className={styles.modal_input}
                  type="num"
                  name="phoneNumber"
                  onChange={handleInputChange}
                  value={
                    useCustomerNumber
                      ? input?.phoneNumber
                      : "0" + userDetails?.phone_no
                  }
                  placeholder="Phone Number"
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    gap: "4px",
                  }}
                >
                  <input
                    type="checkbox"
                    name="useCustomerNumber"
                    onChange={(e) => setUseCustomerNumber(e.target.checked)}
                    checked={useCustomerNumber}
                    style={{ width: "18px", height: "18px" }}
                  />
                  <p style={{ marginLeft: "0px" }}>Use customer's number</p>
                </div>
                <p style={{ marginLeft: "0px" }}>{updateMessage}</p>
                <button
                  disabled={isLoading}
                  style={{
                    cursor: isLoading ? "not-allowed" : "default",
                    opacity: isLoading ? 0.5 : 1,
                  }}
                  className={styles.modal_button}
                  onClick={addCustomerHandler}
                >
                  {isLoading ? `Loading...` : `Add`}
                </button>
              </div>
            ) : (
              <div>
                <img
                  src={successImage}
                  alt="success"
                  style={{
                    width: "130px",
                    height: "134px",
                    gap: "0px",
                    opacity: "0px",
                  }}
                />
                <button
                  className={styles.modal_button}
                  onClick={() => {
                    setCustomerAdded(false);
                    const phoneNo = input.phoneNumber.startsWith("0")
                      ? "234" + input.phoneNumber.slice(1)
                      : input.phoneNumber;
                    if (phoneNo) {
                      const message = `*Welcome to AgentPro!* 🚗✨

Hi,

We're excited to have you on board! With AgentPro, you now have the tools to manage and renew the vehicle papers of your customers quickly and efficiently.

Here's how you can get started:

1. Log in to your AgentPro account to explore your dashboard.
2. Add your customer's vehicle details to protect them from traffic fines. 
3. ⁠Send reminders and renew for them. 
4. ⁠Track all transactions and manage your clients in one place.

If you need any help, feel free to reach out to our support team. We’re here to ensure you succeed!

Welcome once again, and we’re looking forward to working with you! 🚀

Best regards,
The AgentPro Team`;
                      const url = `https://api.whatsapp.com/send?phone=${phoneNo}&text=${encodeURIComponent(
                        message
                      )}`;
                      window.open(url, "_blank");
                    }
                  }}
                >
                  Send whatsapp
                </button>
                <p
                  onClick={() => sendWelcomeSmsText()}
                  style={{
                    textDecoration: "underline",
                  }}
                >
                  {!isLoading ? "SMS" : ""}
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {openModal && (
        <Modal show={openModalHandler} onClose={closeModal} iframeSrc={url} />
      )}
      <Navbar title="Customers" setShowMenu={props.setShowMenu} />

      {!pageIsLoading ? (
        <div className={styles.body}>
          <div className={styles.body_header}>
            <div
              className={`${styles.customer_stat} ${
                filterStatus === "expired" ? styles.active_stat : ""
              }`}
              onClick={() => handleStatClick("expired")}
            >
              <h1>Expired</h1>
              <h1>{customerStatus?.expired}</h1>
            </div>
            <div
              className={`${styles.customer_stat} ${
                filterStatus === "dueSoon" ? styles.active_stat : ""
              }`}
              onClick={() => handleStatClick("dueSoon")}
            >
              <h1>Due Soon</h1>
              <h1>{customerStatus?.dueSoon}</h1>
            </div>
            <div
              className={`${styles.customer_stat} ${
                filterStatus === "active" ? styles.active_stat : ""
              }`}
              onClick={() => handleStatClick("active")}
            >
              <h1>Active</h1>
              <h1>{customerStatus?.active}</h1>
            </div>
          </div>

          <div className={styles.filter_wrapper}>
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search transactions"
              className={styles.filter_input}
            />
            <input
              type="date"
              placeholder="Search transactions"
              className={styles.filter_input}
            />

            <button
              className={styles.export_button}
              onClick={() => setaddCustomerModalOpen(true)}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.0026 2.33594V11.6693M2.33594 7.0026H11.6693"
                  stroke="white"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>

          {/* <div style={{ display: "inline" }}>
          <button
            onClick={() => setPageNumber(pageNumber - 1)}
            disabled={pageNumber === allCustomers?.from}
            style={{
              backgroundColor:
                pageNumber === allCustomers?.from ? "grey" : "#1814F3",
              color: "white",
              padding: "5px 10px",
              margin: "5px",
              border: "none",
              float: "left",
              borderRadius: "5px",
            }}
          >
            Prev
          </button>
          <button
            onClick={() => setPageNumber(pageNumber + 1)}
            disabled={pageNumber === allCustomers?.last_page}
            style={{
              backgroundColor:
                pageNumber === allCustomers?.last_page ? "grey" : "#1814F3",
              color: "white",
              padding: "5px 10px",
              margin: "5px",
              border: "none",
              float: "left",
              borderRadius: "5px",
            }}
          >
            Next
          </button>
        </div> */}

          <Table
            setSendExpiryModal={setSendExpiryModal}
            tableData={filteredCustomers}
            setSendExpiryModalData={setSendExpiryModalData}
            table_type="customers"
            sendLinkToModal={sendLinkToModal}
            openModalHandler={openModalHandler}
          />
        </div>
      ) : (
        <SkeletonLoader />
      )}

      <Footer />
    </div>
  );
}

export default Customers;
